import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_BA.json';
import exercises from './YOGA_EXERCISES_BA.json';
import recipes from './YOGA_RECIPES_BA.json';

export const YOGA_DATA_BA: ServiceData = {
  articles,
  exercises,
  recipes,
};
